import PropTypes from "prop-types";
import Badge from "components/Badge";
import Button from "components/Button";
import AppModal from "components/common/AppModal";
import {
  normalizeProjectStatus,
  PROJECT_STATUS_OPTIONS,
  projectStatusLabel,
} from "utils/projectsList";

export default function ProjectChangeStatusModal({
  open,
  project,
  statusDraft,
  updating,
  onStatusChange,
  onClose,
  onUpdate,
}) {
  if (!project) return null;

  const currentStatus = normalizeProjectStatus(project.status, "draft");
  const statusUnchanged = statusDraft === currentStatus;

  return (
    <AppModal
      open={open}
      title="Change project status"
      onClose={onClose}
      preventClose={updating}
      maxWidth="md"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose} disabled={updating}>
            Cancel
          </Button>
          <Button type="button" onClick={onUpdate} disabled={updating || statusUnchanged}>
            {updating ? "Updating…" : "Update"}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="rounded-lg border border-slate-200 bg-slate-50/80 px-3 py-2.5">
          <p className="text-xs font-semibold uppercase tracking-wide text-text-500">Current status</p>
          <div className="mt-1.5 flex flex-wrap items-center gap-2">
            <Badge status={project.status} />
           
          </div>
          <p className="mt-2 truncate text-xs text-text-500">{project.title}</p>
        </div>

        <div>
          <label htmlFor="project-status-select" className="mb-1 block text-xs font-semibold text-text-500">
            New status
          </label>
          <select
            id="project-status-select"
            value={statusDraft}
            onChange={(event) => {
              const next = event.target.value;
              if (next !== currentStatus) onStatusChange(next);
            }}
            disabled={updating}
            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-text-900 outline-none ring-brand-600 focus:ring-2 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {PROJECT_STATUS_OPTIONS.map(({ value, label }) => (
              <option key={value} value={value} disabled={value === currentStatus}>
                {label}
                {value === currentStatus ? " (current)" : ""}
              </option>
            ))}
          </select>
        </div>
      </div>
    </AppModal>
  );
}

ProjectChangeStatusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string,
    status: PropTypes.string,
  }),
  statusDraft: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
